import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.877 16.315a7.116 7.116 0 111.438-1.438l4.185 4.185-1.438 1.438-4.185-4.185zm.821-5.7a5.083 5.083 0 11-10.165 0 5.083 5.083 0 0110.165 0z" }));
export default createSvgIcon(iconPath, "Search");
//# sourceMappingURL=SearchIcon.js.map